<template>
  <section class="contact-us-module-component">
    <div class="container">
      <div class="contact-hero">
        <img
          :src="props.data.contact_hero.url"
          alt="Image" />

        <div
          :id="contactBox"
          class="content"
          v-html="props.data.contact_hero_content" />
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "ContactUsComponent",
  "CLASSNAME": "contact-us-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */

/*
 *   Insert your logic here
 */

import { ref, onMounted } from 'vue'
import useIntroShown from '@/composables/useIntroShown.js'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import useUtils from '@/composables/useUtils'

const props = defineProps(['data'])

const { genUUID } = useUtils()
const contactBox = ref(`contactBox-${genUUID()}`)

const { introShown } = useIntroShown()

gsap.registerPlugin(ScrollTrigger)

const hasIntroShown = () => {
  if (introShown.value) {
    gsap.fromTo(
      `#${contactBox.value}`,
      {
        y: '100px',
        autoAlpha: 0,
      },
      {
        delay: 1.5,
        duration: 1,
        y: -10,
        autoAlpha: 1,
        ease: 'power1.out',
      }
    ),
      gsap.fromTo(
        `#${contactBox.value} *`,
        {
          autoAlpha: 0,
        },
        {
          delay: 2,
          duration: 1,
          autoAlpha: 1,
          ease: 'power1.out',
        }
      )
  } else {
    setTimeout(() => {
      hasIntroShown()
    }, 100)
  }
}

onMounted(() => {
  hasIntroShown()
})
</script>

<style lang="scss">
.contact-us-module-component {
  @apply relative;

  .container {
    @apply lg:px-7;
  }

  .contact-hero {
    @apply relative mb-16 min-h-[500px] rounded-2xl px-6 pb-[424px] lg:min-h-[750px] lg:pb-14;

    img {
      @apply absolute bottom-0 left-0 right-0 h-[514px] w-full rounded-2xl object-cover object-center lg:top-8 lg:h-full;
    }

    .content {
      @apply relative bg-bicara-dark-blue p-11 lg:ml-auto lg:mr-[80px] lg:w-[520px] lg:-translate-y-5;

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        @apply header-2 mb-7 text-bicara-yellow;
      }

      p {
        @apply body-sm mb-6 break-words leading-7 text-white;

        strong {
          @apply header-5 mb-5 font-light leading-normal text-bicara-turquoise;
        }
      }

      a {
        @apply transition-colors;

        &:hover {
          @apply text-bicara-yellow;
        }
      }
    }
  }
}
</style>
